// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"caf84262","202":"2d0251a3","206":"8d63187d","270":"f0962148","285":"36ea0a27","289":"fd9d06bc","681":"3ebedf5c","705":"3d219694","722":"d5e81532","803":"26bbc24c"}[chunkId] + ".chunk.js";
};